import { useEffect, useState } from 'react';
import classes from './CardsContainer.module.scss'
import { useMemberAccountContext } from '@/context/MemberAccountContext'
import dynamic from 'next/dynamic'

const ReferralCard = dynamic(() => import('./Cards/ReferralCard/ReferralCard'))
const SubscriptionDeliveryCard = dynamic(() => import('./Cards/SubscriptionDeliveryCard/SubscriptionDeliveryCard'))
const AddonCard = dynamic(() => import('./Cards/AddonCard/AddonCard'))
const SubscriptionDeliveryLoadingCard = dynamic(() => import('./Cards/SubscriptionDeliveryLoadingCard/SubscriptionDeliveryLoadingCard'))

export default function CardsContainer({ customer, subscriptions }) {
  const [openOrders, setOpenOrders] = useState([])
  const [openOrdersLoaded, setOpenOrdersLoaded] = useState(false)
  const { availableAddons } = useMemberAccountContext()

  useEffect(() => {
    const load = async () => {
      const idArr = customer.id.split('/')
      const id = idArr[idArr.length - 1]

      const result = await fetch(`/api/account/${id}/open-orders`, {
        method: 'GET',
        headers: {
          'x-account-api-key': process.env.NEXT_PUBLIC_ACCOUNT_ENDPOINT_API_KEY
        }
      }).then((res) => res.json())

      if (result.message === 'success') {
        setOpenOrders(result.data)
      }
      setOpenOrdersLoaded(true)
    }

    if (customer) load()
  }, [customer?.id])

  const renderAddonCards = (subscriptions) => {
    const mostRecentSub = subscriptions[0];
    if (!mostRecentSub) {
      return;
    }

    // See which addons haven't been purchased and we'll show that one in the card
    const unpurchasedAddons = availableAddons.filter(addon => {
      const match = mostRecentSub.subscription_addons.find(selectedAddon => `${selectedAddon.productid}` === `${addon.id}`);
      return !match;
    })

    if (unpurchasedAddons.length > 0) {
      return (
        <div className={classes['card']}>
          <AddonCard addon={unpurchasedAddons[0]} subscription={mostRecentSub}></AddonCard>
        </div>
      )
    }

  }


  const renderOpenOrderCards = () => {
    if (!openOrdersLoaded) {
      return (
        <div className={classes['card']}>
          <SubscriptionDeliveryLoadingCard />
        </div>
      )
    }
    return openOrders.map((order, index) => {
      return (
        <div className={classes['card']} key={`order-card-${index}`}>
          <SubscriptionDeliveryCard
            date={order.estimated_delivery_date}
            type={order.line_items}
            address={order.shipto_address}
          />
        </div>
      )
    })
  }

  return (
    <div className={classes['cards-container']}>
      {renderOpenOrderCards()}
      {renderAddonCards(subscriptions)}
      <div className={classes['card']}>
        <ReferralCard />
      </div>
    </div>
  )
}
